










































































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit, Watch} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Vente} from '@/models';

import CrudVenteFilter from '@/components/Crud/Vente/Filter.vue';
import CrudVenteEditDialog from '@/components/Crud/Vente/EditDialog.vue';
import CrudVenteList from '@/components/Crud/Vente/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import storeVente, {VenteFilter} from '@/stores/modules/vente';

@Component({
	components: {
		CrudVenteFilter,
		CrudVenteEditDialog,
		CrudVenteList,
		CrudDeleteDialog,
	}
})
export default class VenteListView extends Vue {

	@Stored(() => storeVente) private ventes!: ResultType<Vente>;
	@Stored(() => storeVente) private filters!: VenteFilter;

	private imgPath: string = "";

	private editVente: Vente = null;
	private deletedVente: Vente = null;
	private storeVente = storeVente;

	public created(): void {
		this.routeWatcher();
	}

	@Watch('$route')
	private routeWatcher() {
	}

	@Emit()
	private onCreate(): void {
		this.editVente = new Vente();
		this.refresh();
	}

	private refresh(): void {
		storeVente.dispatch('getC', { filters: true });
	}
}
